export var zIndices;
(function (zIndices) {
    zIndices[zIndices["pinned"] = 1010] = "pinned";
    zIndices[zIndices["sticky"] = 1020] = "sticky";
    zIndices[zIndices["positioned"] = 1030] = "positioned";
    zIndices[zIndices["backdrop"] = 1040] = "backdrop";
    zIndices[zIndices["offcanvas"] = 1050] = "offcanvas";
    zIndices[zIndices["modal"] = 1060] = "modal";
    zIndices[zIndices["popover"] = 1070] = "popover";
    zIndices[zIndices["tooltip"] = 1080] = "tooltip";
    zIndices[zIndices["toast"] = 1090] = "toast";
})(zIndices || (zIndices = {}));
//# sourceMappingURL=zIndices.js.map